import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { usePaymentInstrumentsCreateOtherMutation, usePaymentInstrumentsCreateCreditCardRecaptchaV2Mutation, usePaymentInstrumentsCreateCreditCardRecaptchaV3Mutation } from "@/hooks";
import { PAYMENT_METHOD_ID } from "@/lib/constants";
import { useCallback } from "react";
import config from "@/lib/config";
import routes from "@/lib/routes";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
export function useCreatePaymentInstrument(_ref) {
  var _ref$creditCard = _ref.creditCard,
      creditCard = _ref$creditCard === void 0 ? {} : _ref$creditCard,
      _ref$other = _ref.other,
      other = _ref$other === void 0 ? {} : _ref$other;

  var _usePaymentInstrument = usePaymentInstrumentsCreateCreditCardRecaptchaV2Mutation(creditCard),
      _usePaymentInstrument2 = _slicedToArray(_usePaymentInstrument, 1),
      createCreditCardRecaptchaV2 = _usePaymentInstrument2[0];

  var _usePaymentInstrument3 = usePaymentInstrumentsCreateCreditCardRecaptchaV3Mutation(creditCard),
      _usePaymentInstrument4 = _slicedToArray(_usePaymentInstrument3, 1),
      createCreditCardRecaptchaV3 = _usePaymentInstrument4[0];

  var _usePaymentInstrument5 = usePaymentInstrumentsCreateOtherMutation(other),
      _usePaymentInstrument6 = _slicedToArray(_usePaymentInstrument5, 2),
      createOther = _usePaymentInstrument6[0],
      createOtherData = _usePaymentInstrument6[1].data;

  var _useGoogleReCaptcha = useGoogleReCaptcha(),
      executeRecaptcha = _useGoogleReCaptcha.executeRecaptcha;

  var generateTokenCallback = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var response, recaptchaType, recaptchaToken, token, tokenKey;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              response = _ref2.response, recaptchaType = _ref2.recaptchaType, recaptchaToken = _ref2.recaptchaToken;

              if (!(response.result == "OK")) {
                _context.next = 15;
                break;
              }

              token = response.tokenResponse.token;
              tokenKey = response.tokenResponse.tokenKey;

              if (!(recaptchaType === "v2")) {
                _context.next = 8;
                break;
              }

              createCreditCardRecaptchaV2({
                variables: {
                  payment_method_id: 1,
                  replace_flag: false,
                  token: token,
                  token_key: tokenKey,
                  recaptchaTokenV2: recaptchaToken
                }
              });
              _context.next = 13;
              break;

            case 8:
              if (!(recaptchaType === "v3")) {
                _context.next = 13;
                break;
              }

              _context.next = 11;
              return executeRecaptcha("payment_add");

            case 11:
              recaptchaToken = _context.sent;
              createCreditCardRecaptchaV3({
                variables: {
                  payment_method_id: 1,
                  replace_flag: false,
                  token: token,
                  token_key: tokenKey,
                  recaptchaTokenV3: recaptchaToken
                }
              });

            case 13:
              _context.next = 16;
              break;

            case 15:
              if (creditCard !== null && creditCard !== void 0 && creditCard.onError) {
                creditCard.onError("入力内容に誤りがあります。");
              }

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [createCreditCardRecaptchaV2, createCreditCardRecaptchaV3, executeRecaptcha]);
  var createPaymentInstrument = useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
      var paymentMethod, expirationDate, cardNumber, cvv, recaptchaType, recaptchaToken, successUrl, cancelUrl, errorUrl, payload;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (data !== null && data !== void 0 && data.cardNumber) {
                data.cardNumber = data === null || data === void 0 ? void 0 : data.cardNumber.replace(/-/g, "");
              }

              paymentMethod = data.paymentMethod, expirationDate = data.expirationDate, cardNumber = data.cardNumber, cvv = data.cvv, recaptchaType = data.recaptchaType, recaptchaToken = data.recaptchaToken;

              if (!(paymentMethod === PAYMENT_METHOD_ID.CREDIT_CARD)) {
                _context2.next = 6;
                break;
              }

              if (recaptchaType !== "v2" && recaptchaType !== "v3") {
                creditCard.onError("recaptchaType is invalid");
              } else if (typeof com_sbps_system != "undefined") {
                com_sbps_system.generateToken({
                  merchantId: config.sbps.merchantId,
                  serviceId: config.sbps.serviceId,
                  ccNumber: cardNumber,
                  ccExpiration: expirationDate,
                  securityCode: cvv
                }, function (response) {
                  return generateTokenCallback({
                    response: response,
                    recaptchaType: recaptchaType,
                    recaptchaToken: recaptchaToken
                  });
                });
              }

              _context2.next = 12;
              break;

            case 6:
              successUrl = true && "".concat(window.location.origin).concat(routes.sbpsSuccess);
              cancelUrl = true && window.location.origin;
              errorUrl = true && "".concat(window.location.origin).concat(routes.sbpsError);
              payload = (other === null || other === void 0 ? void 0 : other.payload) || {};
              _context2.next = 12;
              return createOther({
                variables: {
                  payment_method_id: paymentMethod,
                  replace_flag: false,
                  success_url: encodeURIComponent(successUrl),
                  cancel_url: encodeURIComponent(cancelUrl),
                  error_url: encodeURIComponent(errorUrl),
                  tokenPayload: _objectSpread(_objectSpread({}, payload), {}, {
                    paymentMethodId: paymentMethod
                  })
                }
              });

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }(), [createOther, generateTokenCallback]);
  return {
    createPaymentInstrument: createPaymentInstrument,
    createOtherData: createOtherData === null || createOtherData === void 0 ? void 0 : createOtherData.paymentInstrumentsCreateOther
  };
}